import { QuaggaComponent } from "../../components/quagga";

export const QuaggaView = () => {
  return <QuaggaComponent />;
};
